import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/AlertDialog';
import { Button } from '@/components/ui/Button';
import { Loader2 } from 'lucide-react';

export interface DeactivatePlayEventSeriesConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  seriesName: string;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
}

export function DeactivatePlayEventSeriesConfirmDialog({
  open,
  onOpenChange,
  seriesName,
  onConfirm,
  loading = false,
}: DeactivatePlayEventSeriesConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(next) => !loading && onOpenChange(next)}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Deactivate series?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-muted-foreground">
              <p>
                <strong className="text-foreground">{seriesName}</strong> will stop generating new
                events until you activate it again.
              </p>
              <p>Scheduled sessions already on the calendar are not cancelled.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button" disabled={loading}>
            Keep active
          </AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            disabled={loading}
            onClick={() => void onConfirm()}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
                Deactivating…
              </>
            ) : (
              'Deactivate'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
